// src/emailConfig.js
export const EMAILJS_CONFIG = {
  SERVICE_ID: 'service_fjrazdr', // Remplacez par votre Service ID
  TEMPLATE_NEWSLETTER: 'template_if3ji4h', // ID du template newsletter
  TEMPLATE_CONTACT: 'template_peki2zm', // ID du template contact
  PUBLIC_KEY: 'oTOwTXiH6m4-imJim' // Remplacez par votre Public Key
};